import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap-accordion';
import faqImage from '../../assets/images/faq/faq-side.png';

Faq3.propTypes = {
  data: PropTypes.array
};

function Faq3(props) {
  const { data } = props;

  const dataBlock = {
    subheading: 'FAQs',
    heading: 'Frequently Asked Questions',
    desc: "Below is a list of frequently asked questions and answers related to PipPlus Tech's trading systems. Please check this FAQ before reaching out to our support team."
  };

  return (
    <section className="faq s3">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE: FAQ content */}
          <div className="col-xl-6 col-md-12">
            <div className="block-text">
              <h6 className="sub-heading"><span>{dataBlock.subheading}</span></h6>
              <h3 className="heading">{dataBlock.heading}</h3>
              <p>{dataBlock.desc}</p>
            </div>

            <div className="faq__main">
              <div className="flat-accordion">
                {data.map(item => (
                  <Accordion show={item.show} key={item.id} title={item.title} className="flat-toggle h6">
                    <p className="toggle-content">{item.text}</p>
                  </Accordion>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT SIDE: FAQ image */}
          <div className="col-xl-6 col-md-12 d-flex align-items-center justify-content-center">
            <div className="image" data-aos="fade-left" data-aos-duration="2000">
              <img src={faqImage} alt="FAQ Visual" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Faq3;
